export default "__VITE_ASSET__BMya$0Fk__"